import React, { useState } from "react";

import {
    Container,
    Row,
    Col,
    Nav,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap";
import classnames from "classnames";

//About Images
import testImg01 from "../../../assets/images/about/img-06.png";
import testImg02 from "../../../assets/images/about/img-07.png";
import testImg03 from "../../../assets/images/about/img-08.png";
import testImg04 from "../../../assets/images/about/img-05.jpg";

const CompanyTestimonal = () => {
    const [activeTab, setActiveTab] = useState("1");

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    return (
        <React.Fragment>
            <section className="section">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={5}>
                            <div className="section-title mb-5 mb-lg-0">
                                <h4 className="title mb-4">What You Get When You Work With Matrix</h4>
                                {/* <p className="text-muted">
                                    We go deeper than job descriptions. We take the time to truly understand a company’s
                                    philosophy, culture, and long-term vision—because that’s what leads to strong, lasting
                                    placements.
                                </p> */}
                                {/* <p className="text-muted" style={{ marginBottom: '-10px' }}>Our approach combines:</p> */}
                                <ul className="list-unstyled about-list text-muted mt-4">
                                    <li>
                                        <strong>Deep Industry Expertise </strong>
                                        <br />
                                        Our recruiters have real-world experience in the industries we serve. We understand the technical
                                        demands, cultural nuances, and long-term challenges our clients face—so we know what the
                                        right hire looks like.
                                    </li>
                                    <li>
                                        <strong>Access to Hidden Talent</strong>
                                        <br />
                                        Through our robust, proprietary database and expansive network, we tap into both active and
                                        passive candidates—including top performers who aren’t actively job hunting. These are the
                                        people who don’t show up on job boards—but who will show up for your business.
                                    </li>
                                    <li>
                                        <strong>Advanced Search Technology</strong>
                                        <br />
                                        We use cutting-edge recruiting tools and AI-driven platforms to identify, vet, and engage the
                                        best-fit candidates faster and more accurately. But it’s not all tech—we balance data-driven
                                        sourcing with human insight and intuition.
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        <Col lg={7}>
                            <Row>
                                <Col md={3}>
                                    <Nav
                                        tabs
                                        className="about-testimonial-menu nav flex-sm-column flex-row nav-pills me-3"
                                    >
                                        <NavLink
                                            className={classnames({ active: activeTab === "1" })}
                                            onClick={() => {
                                                toggle("1");
                                            }}
                                        >
                                            <div className="position-relative">
                                                <img src={testImg01} alt="" className="rounded" />
                                                <div className="about-testi-bg-overlay">
                                                    <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink
                                            className={classnames({ active: activeTab === "2" })}
                                            onClick={() => {
                                                toggle("2");
                                            }}
                                        >
                                            <div className="position-relative">
                                                <img src={testImg02} alt="" className="rounded" />
                                                <div className="about-testi-bg-overlay">
                                                    <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink
                                            className={classnames({ active: activeTab === "3" })}
                                            onClick={() => {
                                                toggle("3");
                                            }}
                                        >
                                            <div className="position-relative">
                                                <img src={testImg03} alt="" className="rounded" />
                                                <div className="about-testi-bg-overlay">
                                                    <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink
                                            className={classnames({ active: activeTab === "2" })}
                                            onClick={() => {
                                                toggle("4");
                                            }}
                                        >
                                            <div className="position-relative">
                                                <img src={testImg04} alt="" className="rounded" />
                                                <div className="about-testi-bg-overlay">
                                                    <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                                                </div>
                                            </div>
                                        </NavLink>
                                    </Nav>
                                </Col>

                                <Col md={9}>
                                    <TabContent
                                        className="about-tab-content h-100"
                                        activeTab={activeTab}
                                    >
                                        <TabPane
                                            tabId="1"
                                            className="fade rounded-3 show"
                                            style={{ backgroundImage: `url(${testImg01})` }}
                                        ></TabPane>
                                        <TabPane
                                            tabId="2"
                                            className="fade rounded-3 show"
                                            style={{ backgroundImage: `url(${testImg02})` }}
                                        ></TabPane>
                                        <TabPane
                                            tabId="3"
                                            className="fade rounded-3 show"
                                            style={{ backgroundImage: `url(${testImg03})` }}
                                        ></TabPane>
                                        <TabPane
                                            tabId="4"
                                            className="fade rounded-3 show"
                                            style={{ backgroundImage: `url(${testImg04})` }}
                                        ></TabPane>
                                    </TabContent>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default CompanyTestimonal;
